import { request } from '../request/request';
import { OpenAPI } from '../request/open-api';
import { CancelablePromise } from '../request/cancelable-promise';
import {
  ECGCaptureResponseDto,
  ECGWaveFormResponseDto,
  StudyComparedEcgWithReferenceResponseDto,
  StudyComparedEcgResponse,
  GetDetailedEcgRequestDto,
} from 'types/types';
import { AppConstants } from 'types/enums';

export const getECGCaptureById = (id: string): CancelablePromise<ECGCaptureResponseDto> => {
  return request(OpenAPI, {
    method: 'GET',
    url: '/ecg-capture/{id}',
    path: {
      id: id,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const getECGWaveformById = (id: string): CancelablePromise<ECGWaveFormResponseDto> => {
  return request(OpenAPI, {
    method: 'GET',
    url: '/ecg-capture/waveform/{id}',
    path: {
      id: id,
      frequency: AppConstants.ECG_FREQUENCY,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const getECGCapturesByFacilityId = (
  id: string,
  skip: number,
  limit: number,
): CancelablePromise<ECGCaptureResponseDto[]> => {
  return request(OpenAPI, {
    method: 'GET',
    url: `/ecg-capture/search-by-facility/${id}`,
    path: {
      id: id,
    },
    query: {
      limit: limit,
      skip: skip,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const getECGCaptureByPatientId = (id: string, limit: number): CancelablePromise<ECGWaveFormResponseDto[]> => {
  return request(OpenAPI, {
    method: 'GET',
    url: `/ecg-capture/waveformsbypatient/${id}/${limit}`,
    path: {
      id: id,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const getPublicWaveformData = (waveformId: string): CancelablePromise<ECGWaveFormResponseDto> => {
  return request(OpenAPI, {
    method: 'GET',
    url: '/public/waveform/{waveformId}',
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
    path: {
      waveformId,
    },
  });
};

export const getStudyComparedEcgData = <T extends GetDetailedEcgRequestDto>(
  requestPayload: T,
): CancelablePromise<
  T['isAnalyzeExist'] extends true ? StudyComparedEcgResponse : StudyComparedEcgWithReferenceResponseDto
> => {
  const { waveformId, isAnalyzeExist } = requestPayload;

  return request(OpenAPI, {
    method: 'GET',
    url: `/study/compared-ecg/`,
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
    query: { waveform_id: waveformId, is_aligned: isAnalyzeExist },
  });
};
